import apiClient from '@/client/api';

export type Resource = {
  title: string;
  url: string;
};

type GetResourcesResponse = Array<Resource>;

async function getResources(route: string): Promise<GetResourcesResponse> {
  const response = await apiClient.get(`/resources/${route}`);
  return response.data;
}

export default { getResources };
